module.exports = __webpack_public_path__ + "img/img13.7c9a2a66.jpg";